module.exports = __webpack_public_path__ + "img/SH2D_300003.8270b57e.png";